import { QueryParams } from 'APIs/types';
import { TextFilterValue } from 'Components/Common/Filters/TextFilter';
import { FilterOption } from 'Components/Common/Filters/types';

export const initFilterOptions: FilterOption[] = [
  {
    option_id: 'merchantId',
    checked: false,
    value: null,
    label: 'Merchant ID',
    optionType: 'text',
  },
  {
    option_id: 'transactionId',
    checked: false,
    value: null,
    label: 'Transaction ID',
    optionType: 'text',
  },
  {
    option_id: 'customerEmailAddress',
    checked: false,
    value: null,
    label: 'Customer Email',
    optionType: 'text',
  },
  {
    option_id: 'referenceOrderId',
    checked: false,
    value: null,
    label: 'Reference Order ID',
    optionType: 'text',
  },
  {
    option_id: 'orderId',
    checked: false,
    value: null,
    label: 'Order ID',
    optionType: 'text',
  },
  {
    option_id: 'currency',
    checked: false,
    value: null,
    label: 'Currency',
    optionType: 'select',
    optionConfig: {
      options: [
        { value: 'AUD', label: 'AUD' },
        { value: 'NZD', label: 'NZD' },
      ],
    },
  },
];

export const filterQueryParams = (filterOptionValues: FilterOption[]): QueryParams => {
  return filterOptionValues.reduce((acc: QueryParams, option) => {
    if (option.checked && option.value !== null) {
      if (option.option_id === 'merchantId') {
        acc['merchantId'] = (option.value as TextFilterValue).text;
      }
      if (option.option_id === 'transactionId') {
        acc['transactionId'] = (option.value as TextFilterValue).text;
      }
      if (option.option_id === 'customerEmailAddress') {
        if (typeof option.value === 'string') {
          acc['customerEmailAddress'] = option.value;
        } else if (typeof option.value === 'object' && option.value !== null && 'text' in option.value) {
          acc['customerEmailAddress'] = (option.value as TextFilterValue).text;
        } else {
          acc['customerEmailAddress'] = String(option.value);
        }
      }
      if (option.option_id === 'referenceOrderId') {
        if (typeof option.value === 'string') {
          acc['referenceOrderId'] = option.value;
        } else if (typeof option.value === 'object' && option.value !== null && 'text' in option.value) {
          acc['referenceOrderId'] = (option.value as TextFilterValue).text;
        } else {
          acc['referenceOrderId'] = String(option.value);
        }
      }
      if (option.option_id === 'orderId') {
        if (typeof option.value === 'string') {
          acc['orderId'] = option.value;
        } else if (typeof option.value === 'object' && option.value !== null && 'text' in option.value) {
          acc['orderId'] = (option.value as TextFilterValue).text;
        } else {
          acc['orderId'] = String(option.value);
        }
      }
      if (option.option_id === 'currency') {
        acc['currency'] = option.value as string;
      }
    }
    return acc;
  }, {});
};
